import Model from "../Model";

export default class extends Model {
  async loadTable(page, limit, search = '', params = {}) {
    let response = await super.list(page, limit, search, params).then(result => {return result});
    let result = {
      tbody: [],
      pages: response.pages,
    };
    if(response.items !== undefined && response.items.length > 0)
    {
      response.items.forEach(mailing => {
        let telem = {
          tbody: {}
        };
        telem.id = mailing.id;
        telem.tbody.name = mailing.name;
        telem.tbody.allow_edit = mailing.allow_edit;
        telem.tbody.type = mailing.type;
        telem.tbody.status = mailing.status;
        telem.tbody.status_color = mailing.status_color;
        telem.tbody.date_sending = mailing.date_sending;
        telem.tbody.status_title = mailing.status_title;
        telem.tbody.letter_subject = mailing.letter_subject;
        telem.tbody.letter_body = mailing.letter_body;
        telem.tbody.sending_type = mailing.sending_type;
        telem.tbody.letter_groups = mailing.letter_groups;
        telem.tbody.letter_sender_name = mailing.letter_sender_name;
        result.tbody.push(telem);
      });
    }
    return result;
  }
}
